<template>
<div>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2 mb-1">
                <label for="date-input">{{ $t('exchangeRateDifferenceReport.date') }}</label>
                <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
            </b-col>
            <b-col class="col-md-10 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" @click="getexchangeRateDifferenceReportList()">{{ $t('others.list') }}</b-button>
                    <b-button style="float:right;" class="ml-1" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                    <b-button :disabled="this.assignCheck" style="float:right;" class="ml-1" size="sm" variant="outline-primary" @click="assignSequenceNo()">{{ $t('exchangeRateDifferenceReport.create_receipt') }}</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table ref="exchangeRateDifferenceReportList" :columns="columns" :rows="exchangeRateDifferenceReportList" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: false, externalQuery: searchTerm }" :select-options="{ enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class',
        selectionText: 'rows selected', clearSelectionText: 'clear', disableSelectInfo: true, selectAllByGroup: true }" :pagination-options="{ enabled: true, perPage:pageLength}" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field ==='accountingTransactionDetailType'" class="text-nowrap">
                {{ $t('exchangeRateDifferenceReport.b_a') }}
            </span>
            <span v-else-if="props.column.field === 'accountingNo'" class="text-nowrap">
                {{ $t('exchangeRateDifferenceReport.account_no') }}
            </span>
            <span v-else-if="props.column.field === 'accountingName'" class="text-nowrap">
                {{ $t('exchangeRateDifferenceReport.account_name') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('exchangeRateDifferenceReport.description') }}
            </span>
            <span v-else-if="props.column.field === 'amount'" class="text-nowrap">
                {{ $t('exchangeRateDifferenceReport.total') }}
            </span>
            <span v-else-if="props.column.field === 'amountCv'" class="text-nowrap">
                {{ $t('exchangeRateDifferenceReport.total_tl') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 10,
            searchTerm: '',
            dir: false,
            pageNo: 1,
            name: '',
            columns: [{
                    label: this.$t('exchangeRateDifferenceReport.b_a'),
                    field: `accountingTransactionDetailType`,
                },
                {
                    label: this.$t('exchangeRateDifferenceReport.account_no'),
                    field: `accountingNo`,
                },
                {
                    label: this.$t('exchangeRateDifferenceReport.account_name'),
                    field: `accountingName`,
                },                
                {
                    label: this.$t('exchangeRateDifferenceReport.description'),
                    field: `description`,
                },
                {
                    label: this.$t('exchangeRateDifferenceReport.total'),
                    field: `amount`,
                    formatFn: this.$formatAmount
                },
                {
                    label: this.$t('exchangeRateDifferenceReport.total_tl'),
                    field: `amountCv`,
                    formatFn: this.$formatAmount
                },
                {
                    label: this.$t('others.process'),
                    field: 'process',
                    width: '10em'
                }
            ],
            exchangeRateDifferenceReportList: [],
            date: new Date().toJSON(),
            assignCheck: true,
        }

    },
    props: {
        subsidiaryLedgerId: {
            type: Number
        }
    },
    methods: {
        getexchangeRateDifferenceReportList() {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'exchangeRateDifferenceReport'
            }
            const data = {
                date: this.date,
                subsidiaryLedgerId: this.subsidiaryLedgerId,
            }
            const payload = {
                data: data,
                controller: controller
            }

            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.exchangeRateDifferenceReportList = response.data.accountingTransactionDetailList
                    if (this.exchangeRateDifferenceReportList.length > 0) {
                        this.assignCheck = false;
                    }
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })

        },
        async getInfo(id) {
            this.$refs.accountingBooksReceiptFormModal.showInfo(id)
        },
        exportExcel() {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                dataList: this.exchangeRateDifferenceReportList,
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Kur Farkı Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        assignSequenceNo() {
            this.$PrivateConfirm(this.$t("exchangeRateDifferenceReport.create_receipt"), this.$t("alerts.create_an_exchange_rate_difference_invoice"), "warning", this.$t("others.ok_title"), this.$t("others.cancel_title")).then(result => {
                if (result.value) {
                    const controller = {
                        name: 'AccountingTransaction',
                        actionName: 'CreateExchangeRateDifferenceRecord'
                    }
                    const data = {
                        accountingTransactionDetailList: this.exchangeRateDifferenceReportList,
                        employeeId: localStorage.getItem('EmployeeId'),
                        subsidiaryLedgerId: this.subsidiaryLedgerId,
                        date: this.date,
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    let loader = this.$loading.show()
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                        loader.hide()
                    })

                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
